import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SetpointsDetail.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialSetpointsState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModelCategoryConfigurationContentTemplate from '../ModelCategoryTab/ModelCategoryConfigurationContentTemplate';
import classNames from 'classnames';
import { isRequired } from '../../utils';
import { v4 as uuid } from 'uuid';
import Cookies from 'js-cookie';
import GoBack from '../WSAControls/GoBack/GoBack';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import { SETPOINTS_TYPE, FLOWSEQUENCE_TYPE, SERVICE_TYPE } from '../../constants';
import Checkbox from '../WSAControls/CheckboxContainer/Checkbox';
import { getQuerystring } from '../../utils';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import InputNumber from '../WSAControls/InputNumber/InputNumber';
import { Fragment } from 'react';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb'

const SetpointsDetail = ({
  intl,
  userProfileWidgets,
  setpoints = {
    ...initialSetpointsState.setpoints
  },
  describeSetpoints,
  saveSetpoints,
  changeSetpoints
}) => {
  const history = useNavigate();
  let { setpointId, ModelCategoryId } = useParams();
  const backLink = `/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints`;
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  //Redirecting
  if (setpoints.redirect) {
    history(backLink);
  }
  //cleanup code
  useEffect(() => {
    return () => {
      changeSetpoints({
        selectedSetpoints: {
          ...initialSetpointsState.selectedSetpoints
        }
      });
    };
  }, [changeSetpoints]);

  let IsEdit = false;

  let IsDuplicate = getQuerystring('duplicate') === '1' || false;

  let type = setpoints.selectedSetpoints.Type || SETPOINTS_TYPE;

  const [formError, setFormError] = useState({});

  setpointId = parseInt(setpointId);
  IsEdit = setpointId !== 0 && !IsDuplicate;

  //Checking permission and redirecting to unauth page if unauthorised
  if (IsEdit && !IsWidgetAccessible(userProfileWidgets, 'SETPOINTSUPDATE')) {
    history('/unauth');
  }
  if (IsDuplicate && !IsWidgetAccessible(userProfileWidgets, 'SETPOINTSCLONE')) {
    history('/unauth');
  }
  if (setpointId === 0 && !IsWidgetAccessible(userProfileWidgets, 'SETPOINTSADDNEW')) {
    history('/unauth');
  }

  let widgetCode = '';

  if (IsEdit) {
    widgetCode = 'SETPOINTSUPDATE';
  } else if (IsDuplicate) {
    widgetCode = 'SETPOINTSCLONE';
  } else {
    widgetCode = 'SETPOINTSADDNEW';
  }

  useEffect(() => {
    changeSetpoints({
      selectedSetpoints: {
        ...initialSetpointsState.setpoints.selectedSetpoints
      }
    });
    if (IsEdit || IsDuplicate) {
      describeSetpoints(setpointId, ModelCategoryId, widgetCode);
    }
  }, [describeSetpoints, changeSetpoints, setpointId, IsEdit, IsDuplicate, ModelCategoryId]);

  //cleanup code
  useEffect(() => {
    return () => {
      changeSetpoints({
        selectedSetpoints: {
          ...initialSetpointsState.setpoints.selectedSetpoints
        }
      });
    };
  }, [changeSetpoints]);

  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = setpoints.selectedSetpoints;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 1;
    saveData.TranslationCode = `setpoints.${saveData.Name.replace(/ /g, '')}`;
    saveData.ModelCategoryId = ModelCategoryId;
    if (!IsEdit) {
      saveData.SetpointId = 0;
      saveData.Type = saveData.Type || SETPOINTS_TYPE;
    }

    if (saveData.Type === SETPOINTS_TYPE) {
      saveData.SequenceCode = null;
    } else if (saveData.Type === SERVICE_TYPE) {
      saveData.SequenceCode = null;
      saveData.DefaultValue = null;
      saveData.UnitOfMeasure = null;
    } else {
      saveData.DefaultValue = null;
      saveData.UnitOfMeasure = null;
    }
    saveSetpoints(saveData, widgetCode);
  };

  const validateInput = () => {
    let formError = {};

    let isValid = true;

    if (
      !setpoints ||
      !setpoints.selectedSetpoints ||
      !setpoints.selectedSetpoints.Name ||
      isRequired(setpoints.selectedSetpoints.Name, 1)
    ) {
      formError.Name = intl.formatMessage({
        id: 'setpointsManagement.nameMandatory',
        defaultMessage: 'Name is a mandatory field'
      });
      isValid = false;
    }

    if (
      !setpoints ||
      !setpoints.selectedSetpoints ||
      !setpoints.selectedSetpoints.SetpointGroup ||
      isRequired(setpoints.selectedSetpoints.SetpointGroup, 1)
    ) {
      formError.SetpointGroup = intl.formatMessage({
        id: 'setpointsManagement.setpointGroupMandatory',
        defaultMessage: 'Setpoint Group is a mandatory field'
      });
      isValid = false;
    }


    if (
      !setpoints ||
      !setpoints.selectedSetpoints ||
      !setpoints.selectedSetpoints.Code ||
      isRequired(setpoints.selectedSetpoints.Code, 1)
    ) {
      formError.Code = intl.formatMessage({
        id: 'setpointsManagement.codeMandatory',
        defaultMessage: 'Code is a mandatory field'
      });
      isValid = false;
    }

    if (type === SETPOINTS_TYPE && setpoints && setpoints.selectedSetpoints) {
      let defValue = setpoints.selectedSetpoints.DefaultValue;
      let minValue = setpoints.selectedSetpoints.MinimumValue;
      let maxValue = setpoints.selectedSetpoints.MaximumValue;

      if (minValue !== '' && maxValue !== '') {
        if (maxValue < minValue) {
          formError.MaximumValue = intl.formatMessage({
            id: 'setpointsManagement.maxValuemustbeGrater',
            defaultMessage: 'Max value must be grater than Min value'
          });
          isValid = false;
        }
      }

      if (defValue !== '') {
        if ((minValue !== '' && defValue < minValue) || (maxValue !== '' && defValue > maxValue)) {
          formError.DefaultValue = intl.formatMessage({
            id: 'setpointsManagement.defaultValueWithinRange',
            defaultMessage: 'Default value must be within Min and Max range'
          });
          isValid = false;
        }
      }
    }

    if (
      type === FLOWSEQUENCE_TYPE &&
      (!setpoints ||
        !setpoints.selectedSetpoints ||
        !setpoints.selectedSetpoints.SequenceCode ||
        isRequired(setpoints.selectedSetpoints.SequenceCode, 1))
    ) {
      formError.SequenceCode = intl.formatMessage({
        id: 'setpointsManagement.sequenceMandatory',
        defaultMessage: 'Sequence code is a mandatory field'
      });
      isValid = false;
    }

    if (
      type === FLOWSEQUENCE_TYPE &&
      setpoints &&
      setpoints.selectedSetpoints &&
      setpoints.selectedSetpoints.SequenceCode &&
      isNaN(setpoints.selectedSetpoints.SequenceCode)
    ) {
      formError.SequenceCode = intl.formatMessage({
        id: 'setpointsManagement.sequenceNumeric',
        defaultMessage: 'Sequence code must be numeric value'
      });
      isValid = false;
    }

    setFormError(formError);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    if (e.target && e.target.type && e.target.type === 'checkbox') {
      setpoints.selectedSetpoints = {
        ...setpoints.selectedSetpoints,
        [e.target.name]: e.target.checked
      };
    } else {
      if ((e.target.name == 'DefaultValue' || e.target.name == 'MinimumValue' || e.target.name == 'MaximumValue') && e.target.value != '') {
        setpoints.selectedSetpoints = {
          ...setpoints.selectedSetpoints,
          [e.target.name]: Number(e.target.value)
        };

      } else {
        setpoints.selectedSetpoints = {
          ...setpoints.selectedSetpoints,
          [e.target.name]: e.target.value
        };

      }

    }
    changeSetpoints(setpoints);
  };

  const setpointsTypeOptions = () => {
    let lblSetpointsType = intl.formatMessage({
      id: 'setpointsManagement.setpoint',
      defaultMessage: 'Setpoint'
    });

    let lblFlowSequenceType = intl.formatMessage({
      id: 'setpointsManagement.flowSequence',
      defaultMessage: 'Flow Sequence'
    });

    let lblServiceType = intl.formatMessage({
      id: 'setpointsManagement.serviceType',
      defaultMessage: 'Service Type'
    });

    let typeOptions = [
      {
        label: lblSetpointsType,
        value: SETPOINTS_TYPE
      },
      {
        label: lblFlowSequenceType,
        value: FLOWSEQUENCE_TYPE
      },
      {
        label: lblServiceType,
        value: SERVICE_TYPE
      }
    ];
    return [...typeOptions];
  };

  const onDropdownChange = e => {
    setpoints.selectedSetpoints = {
      ...setpoints.selectedSetpoints,
      Type: e.value
    };
    changeSetpoints(setpoints);
  };

  let messageId = (setpoints && setpoints.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const setpointsName = (setpoints.selectedSetpoints ? setpoints.selectedSetpoints.Name : '') || '';
  let heading = '';
  if (IsEdit) {
    heading = intl.formatMessage({ id: 'setpointsManagement.edit', defaultMessage: 'Edit' }) + ' ' + setpointsName;
  } else if (IsDuplicate) {
    heading = intl.formatMessage({ id: 'setpointsManagement.duplicate', defaultMessage: 'Duplicate' });
  } else {
    heading = intl.formatMessage({ id: 'setpointsManagement.addNewSetpoint', defaultMessage: 'Add new setpoints' });
  }

  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="setpointsManagement.setpoints" defaultMessage="Setpoints" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/setpoints` },
    { label: heading } // Last item has no href (current page)
  ];

  return (
    <div className={s.setpoints}>
      {setpoints.isLoading && <LoadingSpinner />}
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={setpoints.showBanner}
        status={setpoints.isOpSuccessful}
        successText={messageText}
      />

      <ModelCategoryConfigurationContentTemplate selectedPage="setpoints" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.setpointsHeader}>
            {/* <GoBack returnUrl={backLink}>
              &lt; &nbsp;
              <FormattedMessage id="setpointsManagement.backToSetpoints" defaultMessage="BACK TO GLOBAL SETTINGS" />
            </GoBack> */}
            <Row>
              <Col>
                <h3 data-unittest="headingLabel">{heading}</h3>
              </Col>
            </Row>
            <div className='pb-3'>
              <Breadcrumb items={breadcrumbItems} />
            </div>
          </div>
          <div className={s.setpointsContent}>
            <Form className={s.viewRow}>
              <Row>
                <Col xs={12} lg={6}>
                  <Form.Group controlId="formSetpointsName">
                    <Form.Label>
                      <FormattedMessage id="setpointsManagement.name" defaultMessage="Name" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Name"
                      onChange={onChange}
                      value={setpoints.selectedSetpoints.Name}
                      className={`${s.formControl} ${formError && formError.Name ? s.formControlError : ''}`}
                      placeholder={intl.formatMessage({
                        id: 'setpointsManagement.name',
                        defaultMessage: 'Name'
                      })}
                    />
                    {formError && formError.Name && (
                      <p role="alert" className={s.error}>
                        {formError.Name}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <Form.Group controlId="formSetpointsName">
                    <Form.Label>
                      <FormattedMessage id="setpointsManagement.setpointGroupName" defaultMessage="Setpoint Group" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="SetpointGroup"
                      onChange={onChange}
                      value={setpoints.selectedSetpoints.SetpointGroup}
                      className={`${s.formControl} ${formError && formError.SetpointGroup ? s.formControlError : ''}`}
                      placeholder={intl.formatMessage({
                        id: 'setpointsManagement.setpointGroupName',
                        defaultMessage: 'Setpoint Group'
                      })}
                    />
                    {formError && formError.SetpointGroup && (
                      <p role="alert" className={s.error}>
                        {formError.SetpointGroup}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <Form.Group controlId="formSetpointsGroupName">
                    <Form.Label>
                      <FormattedMessage id="setpointsManagement.groupName" defaultMessage="Group Name" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="GroupName"
                      onChange={onChange}
                      value={setpoints.selectedSetpoints.GroupName}
                      placeholder={intl.formatMessage({
                        id: 'setpointsManagement.groupName',
                        defaultMessage: 'Group Name'
                      })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <Form.Group controlId="formSetpointsType">
                    <Form.Label>
                      <FormattedMessage id="setpointsManagement.type" defaultMessage="Type" />
                    </Form.Label>
                    <Dropdown
                      id="formSetpointsType"
                      dataArray={setpointsTypeOptions()}
                      controlData={{ placeholderText: 'Type', customClassName: '' }}
                      onDropdownChange={onDropdownChange}
                      data-unittest="formSetpointsType"
                      selectedOption={setpointsTypeOptions().filter(option => option.value === type)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <Form.Group controlId="formSetpointsCode">
                    <Form.Label>
                      <FormattedMessage id="setpointsManagement.code" defaultMessage="Code" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Code"
                      onChange={onChange}
                      value={setpoints.selectedSetpoints.Code}
                      className={`${s.formControl} ${formError && formError.Code ? s.formControlError : ''}`}
                      placeholder={intl.formatMessage({
                        id: 'setpointsManagement.code',
                        defaultMessage: 'Code'
                      })}
                    />
                    {formError && formError.Code && (
                      <p role="alert" className={s.error}>
                        {formError.Code}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group controlId="formSetpointsDescription">
                    <Form.Label>
                      <FormattedMessage id="setpointsManagement.description" defaultMessage="Description" />
                    </Form.Label>

                    <Form.Control
                      className={s.txtArea}
                      as="textarea"
                      rows="3"
                      name="Description"
                      onChange={onChange}
                      placeholder={intl.formatMessage({
                        id: 'setpointsManagement.description',
                        defaultMessage: 'Description'
                      })}
                      value={setpoints.selectedSetpoints.Description}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {type === SETPOINTS_TYPE && (
                <Fragment>
                  <Row>
                    <Col xs={12} lg={2}>
                      <Form.Group controlId="formSetpointsDefaultValue">
                        <Form.Label>
                          <FormattedMessage id="setpointsManagement.defaultValue" defaultMessage="Default value" />
                        </Form.Label>

                        <InputNumber
                          name="DefaultValue"
                          step=".1"
                          onInputChange={onChange}
                          value={setpoints.selectedSetpoints.DefaultValue}
                          id="formSetpointDefaultValue"
                          customClassName={`${formError && formError.DefaultValue ? s.formControlError : ''}`}
                        />
                        {formError && formError.DefaultValue && (
                          <p role="alert" className={`${s.error} d-block d-lg-none`}>
                            {formError.DefaultValue}
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Group controlId="formSetpointsMinValue">
                        <Form.Label>
                          <FormattedMessage id="setpointsManagement.minValue" defaultMessage="Min value" />
                        </Form.Label>
                        <InputNumber
                          name="MinimumValue"
                          step=".1"
                          onInputChange={onChange}
                          value={setpoints.selectedSetpoints.MinimumValue}
                          id="formSetpointMinimumValue"
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Group controlId="formSetpointsMaxValue">
                        <Form.Label>
                          <FormattedMessage id="setpointsManagement.maxValue" defaultMessage="Max value" />
                        </Form.Label>
                        <InputNumber
                          name="MaximumValue"
                          step=".1"
                          onInputChange={onChange}
                          value={setpoints.selectedSetpoints.MaximumValue}
                          id="formSetpointMaximumValue"
                          customClassName={`${formError && formError.MaximumValue ? s.formControlError : ''}`}
                        />
                        {formError && formError.MaximumValue && (
                          <p role="alert" className={`${s.error} d-block d-lg-none `}>
                            {formError.MaximumValue}
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="d-none d-lg-block">
                    <Col>
                      {formError && formError.DefaultValue && (
                        <p role="alert" className={s.error}>
                          {formError.DefaultValue}
                        </p>
                      )}
                      {formError && formError.MaximumValue && (
                        <p role="alert" className={s.error}>
                          {formError.MaximumValue}
                        </p>
                      )}
                    </Col>
                  </Row>
                </Fragment>
              )}
              {type === SETPOINTS_TYPE && (
                <Row>
                  <Col xs={12} lg={6}>
                    <Form.Group controlId="formSetpointsUnitOfMeasure">
                      <Form.Label>
                        <FormattedMessage id="setpointsManagement.unitOfMeasure" defaultMessage="Unit of measure" />
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="UnitOfMeasure"
                        onChange={onChange}
                        value={setpoints.selectedSetpoints.UnitOfMeasure}
                        className={`${s.formControl}`}
                        placeholder={intl.formatMessage({
                          id: 'setpointsManagement.unitOfMeasure',
                          defaultMessage: 'Unit of measure'
                        })}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {type === FLOWSEQUENCE_TYPE && (
                <Row>
                  <Col xs={12} lg={6}>
                    <Form.Group controlId="formSetpointsSequenceCode">
                      <Form.Label>
                        <FormattedMessage id="setpointsManagement.sequenceCode" defaultMessage="Sequence code" />
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="SequenceCode"
                        onChange={onChange}
                        value={setpoints.selectedSetpoints.SequenceCode || ''}
                        className={`${s.formControl} ${formError && formError.SequenceCode ? s.formControlError : ''}`}
                        placeholder={intl.formatMessage({
                          id: 'setpointsManagement.sequenceCode',
                          defaultMessage: 'Sequence code'
                        })}
                      />
                      {formError && formError.SequenceCode && (
                        <p role="alert" className={s.error}>
                          {formError.SequenceCode}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              )}

              {type === FLOWSEQUENCE_TYPE && (
                <Row>
                  <Col xs={12} lg={6}>
                    <Form.Group controlId="formIsPredefined">
                      <Checkbox
                        key={uuidv4()}
                        dataArray={[
                          {
                            SKEY: 'IsPredefined',
                            target: { type: 'checkbox' },
                            label: intl.formatMessage({
                              id: 'setpointsManagement.predefined',
                              defaultMessage: 'Predefined'
                            }),
                            isChecked: setpoints.selectedSetpoints.IsPredefined
                          }
                        ]}
                        onSelectionChange={onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              {type === FLOWSEQUENCE_TYPE && (
                <Row>
                  <Col xs={12} lg={6}>
                    <Form.Group controlId="formIsUninterruptible">
                      <Checkbox
                        key={uuidv4()}
                        dataArray={[
                          {
                            SKEY: 'IsUninterruptible',
                            target: { type: 'checkbox' },
                            label: intl.formatMessage({
                              id: 'setpointsManagement.isuninterruptible',
                              defaultMessage: 'Is Uninterruptible'
                            }),
                            isChecked: setpoints.selectedSetpoints.IsUninterruptible
                          }
                        ]}
                        onSelectionChange={onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              <Row>
                <Col xs={12} lg={6}>
                  <Form.Group controlId="formIsActive">
                    <Checkbox
                      key={uuidv4()}
                      dataArray={[
                        {
                          SKEY: 'IsActive',
                          target: { type: 'checkbox' },
                          label: intl.formatMessage({
                            id: 'setpointsManagement.active',
                            defaultMessage: 'Active'
                          }),
                          isChecked: setpoints.selectedSetpoints.IsActive
                        }
                      ]}
                      onSelectionChange={onChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className={s.btnRow}>
                  <Button
                    variant="primary"
                    data-unittest="saveData"
                    className={classNames(s.margin5, s.btnSaveChanges)}
                    onClick={submitForm}
                    noValidate
                  >
                    <FormattedMessage id="setpointsManagement.save" defaultMessage="Save" />
                  </Button>
                  <Link to={backLink}>
                    <Button variant="outline-secondary" className={s.btnCancel}>
                      <FormattedMessage id="setpointsManagement.cancel" defaultMessage="Cancel" />
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModelCategoryConfigurationContentTemplate>
    </div>
  );
};


SetpointsDetail.propTypes = {
  saveSetpoints: PropTypes.func.isRequired,
  setpoints: PropTypes.object.isRequired,
  describeSetpoints: PropTypes.func.isRequired,
  changeSetpoints: PropTypes.func.isRequired
};

export default injectIntl(SetpointsDetail);
